import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { CompanyQueryKey } from './queryKey';
export var useGetCompanies = function () {
    var intl = useIntl();
    return useQuery([CompanyQueryKey.Companies], function () { return api.base.get('/api/company/GetAll').then(function (res) { return res.data; }); }, {
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
